<ion-button (click)="doClick($event)" [ngClass]="mainClass" [color]="color" [size]="size" [expand]="expand" [fill]="fill" [disabled]="isDisabled">
    <ng-content></ng-content>
    <ion-spinner *ngIf="!hideSpinner" [ngClass]="mainClass" [style.visibility]="(spinner || _autoSpinnerValue) ? 'visible' : 'hidden'"></ion-spinner>
</ion-button>
<div *ngIf="isDisabled" class="overlay" (click)="doClick($event)"></div>